import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import banner from "../../assets/images/banner.jpg"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay } from "swiper"
import styled from "styled-components"

const LogosStrip = () => {
  const {
    allPrismicPartners: { edges: images },
  } = useStaticQuery(graphql`
    query {
      allPrismicPartners(sort: { fields: data___logo___alt, order: ASC }) {
        edges {
          node {
            data {
              logo {
                gatsbyImageData
                alt
              }
              status
            }
          }
        }
      }
    }
  `)

  return (
    <Section>
      <BgImage>
        <picture>
          <img src={banner} alt="banner" loading="lazy" />
        </picture>
      </BgImage>
      <Container>
        <StyledSwiper
          slidesPerView={3}
          spaceBetween={20}
          modules={[Autoplay]}
          loop={true}
          speed={1000}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          allowTouchMove={false}
          breakpoints={{
            567: { slidesPerView: 4, spaceBetween: 20 },
            768: { slidesPerView: 6, spaceBetween: 47 },
          }}
          observer={true}
          autoHeight={true}
        >
          {images?.map((el, i) => {
            const basePath = el?.node?.data?.logo
            return (
              <SwiperSlide key={i}>
                <GatsbyImage
                  alt={basePath?.alt ?? ''}
                  image={basePath?.gatsbyImageData}
                  loading="lazy"
                />
              </SwiperSlide>
            )
          })}
        </StyledSwiper>
      </Container>
    </Section>
  )
}

export default LogosStrip

const Section = styled.section`
  position: relative;
  min-height: 104px;
  padding: 22px 0;
  height: 109px;

  @media (min-width: ${({ theme }) => theme.media.mobile_max}) {
    height: 200px;
  }
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    height: 280px;
    padding: 60px 0;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
  }
`

const BgImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  picture {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
const Container = styled.div`
  ${({ theme }) => theme.container};
  display: flex;
  align-items: center;
  height: 100%;

  .swiper {
    height: 100%;
    display: flex;
    align-items: center;

    .swiper-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
`

const StyledSwiper = styled(Swiper)`
  .gatsby-image-wrapper {
    height: 120px;

    @media (max-width: 576px) {
      height: 60px;
    }

    img {
      object-fit: contain !important;
      height: 100%;
    }
  }
`
